import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { FC } from 'react';
// Components
import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Divider,
  FormControlLabel,
  FormLabel,
  Typography
} from '@mui/material';
import { IDelayedJob } from '../../../models';

interface IMobileDelayStarts {
  original: IDelayedJob;
  selectedJobs: any[];
  setSelectedJobs: (val: any[]) => void;
}

export const MobileDelayStarts: FC<IMobileDelayStarts> = ({
  original,
  selectedJobs,
  setSelectedJobs
}) => {
  const classes = useStyles();
  const ids = selectedJobs.map(job => job.jobId);
  const isSelected = ids.includes(original.jobId);
  const showCheckbox = true;
  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          {showCheckbox && (
            <FormControlLabel
              classes={{
                root: classes.tableCheckbox
              }}
              color="primary"
              control={
                <Checkbox
                  checked={isSelected}
                  id="orders-checkbox"
                  onClick={e => {
                    e.stopPropagation();
                    isSelected
                      ? setSelectedJobs(selectedJobs.filter(jobs => jobs.jobId !== original.jobId))
                      : setSelectedJobs([...selectedJobs, original]);
                  }}
                />
              }
              label=""
            />
          )}
          <Divider orientation="vertical" flexItem className={classes.divider} />
          <Typography className={classes.activeName}>
            {original.jobId} {original.neighborhood}
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Neighborhood:
          </FormLabel>
          <Typography component="span">{original.neighborhood || '--'}</Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Phase:
          </FormLabel>
          <Typography component="span">{original.neighborhoodPhase || '--'}</Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Lot:
          </FormLabel>
          <Typography component="span">{original.lotNumber || '--'}</Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            PM:
          </FormLabel>
          <Typography component="span">{original.projectManager || '--'}</Typography>
        </div>

        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Super:
          </FormLabel>
          <Typography component="span">{original.supervisor || '--'}</Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Start Week:
          </FormLabel>
          <Typography component="span">{original.startWeek || '--'}</Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Form Date:
          </FormLabel>
          <Typography component="span">{original.formDateDisplay || '--'}</Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Frame Date:
          </FormLabel>
          <Typography component="span">{original.frameDateDisplay || '--'}</Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  roleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    padding: `2px 5px`
  },
  approveButton: {
    padding: `2px 5px`
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10
  },
  buttonsWrapper: {
    display: 'flex'
  },
  activeName: {
    color: theme.palette.grey[500]
  },
  divider: {
    margin: '0 5px'
  },
  part: {
    flex: 1
  },
  statusRed: {
    color: theme.palette.error.main
  },
  tableCheckbox: {
    marginRight: 0
  }
}));
